import { PaymentIntegrationsState, ProviderStripeStatus } from './types';

export const initialState: PaymentIntegrationsState = {
  stripe: {
    status: ProviderStripeStatus.FETCHING,
    accountEmail: null,
  },
};
